<template>
  <img class="image" alt='image' :src="imageSrc"/>
</template>

<script>
import NullStates from '~/assets/images/null-states'

export default {
  name: 'NullStateImage',
  props: {
    image: {
      type: String,
      required: false,
      default: 'search',
      validator: value => Object.keys(NullStates).includes(value)
    }
  },
  computed: {
    imageSrc () {
      return NullStates[this.image]
    }
  }
}
</script>


<style lang="scss" scoped>

.image {
  @include ratio(1,1);
  width: 160px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin-bottom: $space-060;
  @include lazy-load;
}
</style>